import { render, staticRenderFns } from "./yearDurationStatistics.vue?vue&type=template&id=35667550&"
import script from "./yearDurationStatistics.vue?vue&type=script&lang=js&"
export * from "./yearDurationStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports